module.exports = __webpack_public_path__ + "89c27bbd7d9a66f4309a361418c4ca5a.svg";